import amplitude from 'amplitude-js';
var amplitudeEvent = function (_a) {
    var event = _a.event, eventProperties = _a.eventProperties;
    amplitude.logEvent(event, eventProperties);
};
export default amplitudeEvent;
